import { ReactElement } from "react";

interface IProps {
  id?: number;
  url?: string;
  onClickNextEx: () => void;
}

export function VideoLesson(props: IProps): ReactElement {
  return (
    <>
      <video className="mainPage_VideoPad" loop autoPlay >
        <source src={"/"+props.url} type="video/mp4" />
      </video>

      <div className="lessonPageOnward-button" onClick={()=>props.onClickNextEx()}>
        Далее
      </div>
    </>
  );
}
